import script from "./PanelOptions.vue?vue&type=script&setup=props&lang=js"
export * from "./PanelOptions.vue?vue&type=script&setup=props&lang=js"

export default script